function convertFromLowDPIToHighDPI(unit: number = 1, lowDPI: number = 72, highDPI: number = 300): number {
    return (unit * highDPI) / lowDPI;
}

function convertFromHighDPIToLowDPI(unit: number = 1, highDPI: number = 300, lowDPI: number = 72): number {
    return (unit * lowDPI) / highDPI;
}

function convertMMToPixel(mm: number, dpi: number = 300): number {
    return (mm * dpi) / 25.4;
}

function convertPixelToMM(pixels: number, dpi: number = 300): number {
    return (pixels * 25.4) / dpi;
}
export { convertFromHighDPIToLowDPI, convertFromLowDPIToHighDPI, convertMMToPixel, convertPixelToMM };
